function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 86,
  r: 85.5,
  fill: "#fff",
  stroke: "#282E5B"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M95.397 54.522c0-21.236-10.148-39.532-17.92-45.522 0 0-.54-.327-.54.544-.648 41.057-21.267 52.274-32.71 67.194-26.234 34.631-1.836 72.53 22.994 79.5 13.926 3.92-3.239-6.97-5.398-29.84-2.59-27.77 33.574-48.898 33.574-71.876",
  fill: "#282E5B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.001 68.57c-.108-.109-.324-.109-.54 0l-.108.11c-.432 5.118-6.046 16.226-13.063 26.354C71.432 129.447 85.035 146 92.7 154.93c4.425 5.227 0 0 11.119-5.336.863-.436 21.591-11.544 23.858-36.701 2.267-24.503-13.171-39.859-18.676-44.324",
  fill: "#059BDC"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M154.669 113.271c-5.944 23.842-30.093 38.352-53.938 32.407-23.835-5.944-38.345-30.094-32.398-53.934 5.941-23.845 30.09-38.356 53.927-32.412 23.843 5.944 38.352 30.096 32.408 53.939h.001z",
  fill: "#F7931A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M131.201 96.1c.886-5.924-3.623-9.107-9.789-11.231l2-8.023-4.883-1.217-1.948 7.812c-1.284-.32-2.602-.622-3.912-.921l1.961-7.863-4.881-1.217-2.001 8.02a161.6 161.6 0 01-3.119-.733l.006-.025L97.9 79.02l-1.299 5.216s3.624.83 3.547.882c1.978.493 2.335 1.803 2.276 2.84l-2.278 9.14c.136.035.312.085.507.163-.163-.04-.336-.085-.516-.128l-3.194 12.804c-.241.601-.855 1.502-2.237 1.16.049.071-3.55-.886-3.55-.886l-2.425 5.59 6.356 1.585c1.182.296 2.34.606 3.482.898l-2.021 8.115 4.878 1.217 2.001-8.029c1.333.362 2.626.696 3.892 1.01l-1.995 7.991 4.884 1.217 2.021-8.1c8.328 1.576 14.59.941 17.225-6.591 2.124-6.065-.105-9.563-4.487-11.844 3.191-.736 5.595-2.835 6.236-7.17l-.002-.001zm-11.158 15.646c-1.509 6.064-11.72 2.786-15.03 1.964l2.681-10.751c3.311.827 13.926 2.462 12.349 8.787zm1.51-15.735c-1.376 5.516-9.875 2.714-12.632 2.027l2.432-9.75c2.756.687 11.635 1.97 10.201 7.723h-.001z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(33 9)",
  d: "M0 0h95v148H0z"
})));

function SvgHbtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbtc);
export default __webpack_public_path__ + "static/media/HBTC.cf8a80ba.svg";
export { ForwardRef as ReactComponent };